import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Pagination,
} from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import UserService from "src/service/userService";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Vehicle Allotment to User",
  },
];

const validationSchema = yup.object({
  user_id: yup.string().required("User is required"),
});

const AllotVehicleToThanaUser = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [UserList, setUserList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(18);

  const fetch_userList = async () => {
    try {
      const res = await UserService.getUserListToAllot({
        district_id:sessionData.data.district_id
      });
      setUserList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchVehicleList = async () => {
    try {
      const res = await UserService.fetchVehicleListForAllotment({
        district_id: sessionData.data.district_id,
      });
      setVehicleList(res.data);
      setFilteredVehicles(res.data); 
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchVehicleList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.district_id]);

  const initialValues = {
    user_id: "",
    district_id: sessionData.data.district_id,
    vehicle_no: [],
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const {  search, ...finalValues } = values;
        try {
          const res = await UserService.allotvehicledata(
            finalValues
          );
          swal("success", res.message, "success");
          // Reset form values
          values.user_id = "";
          values.vehicle_no = [];
          fetchVehicleList();
          setTimeout(() => {
            navigate("/allotvehicletothanauser");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  useEffect(() => {
    fetch_userList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter vehicles based on search query
  useEffect(() => {
    const filtered = vehicleList.filter((vehicle) =>
      vehicle.vehicle_no.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredVehicles(filtered);
  }, [searchQuery, vehicleList]);

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    handleChange(event);
  };

  // Calculate the displayed vehicles based on the current page and items per page
  const indexOfLastVehicle = currentPage * itemsPerPage;
  const indexOfFirstVehicle = indexOfLastVehicle - itemsPerPage;
  const currentVehicles = filteredVehicles.slice(
    indexOfFirstVehicle,
    indexOfLastVehicle
  );

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div>
      <Breadcrumb title="Vehicle Allotment" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid item xs={4}>
            <Typography
              variant="h2"
              sx={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
            >
              Vehicle Allotment To User
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="user_id">
                User Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="user_id"
                name="user_id"
                options={UserList}
                getOptionLabel={(option) => `${option.username}`}
                value={
                    UserList.find((item) => item.id === values.user_id) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "user_id", value: newValue?.id || "" },
                  });
                  
                }}
                onBlur={handleBlur}
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    error={touched.user_id && Boolean(errors.user_id)}
                    helperText={touched.user_id && errors.user_id}
                    fullWidth
                    variant="outlined"
                    placeholder="Search or select User"
                  />
                )}
              />
            </Grid>
            
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <CustomFormLabel htmlFor="radius">
                Search vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="search"
                name="search"
                type="text"
                value={searchQuery} // Bind search query state
                onChange={handleSearchChange} // Handle search input change
                onBlur={handleBlur}
                error={touched.search && Boolean(errors.search)}
                helperText={touched.search && errors.search}
                variant="outlined"
                placeholder="Search vehicle No"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle Number <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>

              <Grid container spacing={3} style={{ marginTop: "10px" }}>
                {currentVehicles.length > 0 ? (
                  currentVehicles.map((vehicle) => (
                    <Grid
                      item
                      lg={2}
                      md={3}
                      sm={4}
                      xs={6}
                      key={vehicle.vehicle_no}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              values.vehicle_no?.includes(vehicle.vehicle_no) || false
                            }
                            onChange={handleChange}
                            name="vehicle_no"
                            value={vehicle.vehicle_no}
                          />
                        }
                        label={`${vehicle.vehicle_no}`}
                      />
                    </Grid>
                  ))
                ) : (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h6 style={{ textAlign: "center", color: "red" }}>
                      No Vehicles Found !!
                    </h6>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Pagination
                count={Math.ceil(filteredVehicles.length / itemsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AllotVehicleToThanaUser;


